import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  IconButton,
} from '@mui/material';
import { X } from '@phosphor-icons/react';

type Props = {
  open: boolean;
  onClose: () => void;
  expiryDate: string;
  setExpiryDate: (val: string) => void;
  onSave: () => void | Promise<void>;
};

export default function EditExpiryModal({
  open,
  onClose,
  expiryDate,
  setExpiryDate,
  onSave,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          Edit Expiry Date
          <IconButton onClick={onClose}>
            <X size={24} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Licences expire at"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
            fullWidth
            type="date"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button variant="contained" onClick={onSave}>
          Save
        </Button>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
